exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-home {\n}\n.apps-container {\r\n    padding: 0 10px 0 30px;\n}\n.grid-content-apps a {\r\n    color: #9D2449;\n}\r\n", ""]);

// exports
